import { defineAction } from '~/prix'
import actionJson from './roadMaintenanceImageDelete.action.json' with { type: 'json' }
import { z } from 'zod'
import roadMaintenanceImageObject from '../roadMaintenanceImageObject'

const definition = defineAction({
  ...actionJson,
  input: z.object({
    id: roadMaintenanceImageObject.shape.id,
  }),
  output: z.object({}),
})

export default definition
